import { apiCall } from "./authServices"

export const GetEmployeeData = async ({ payload }) => {

    try {
        const endPoint = `api/employee-master/get-employees`
        const res = await apiCall({
            endpoint: endPoint,
            payload: payload,
            method: "POST"
        });
        return res;
    }
    catch (err) {
        throw err;
    }
}

export const UpdateEmployee = async ({ payload }) => {

    const { id } = payload
    try {
        const endpoint = `api/employee-master/update-employee/${id}`
        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "PUT"
        });
        return res;
    }
    catch (error) {
        throw error
    }
}
export const GetUserRights = async ({ empCode }) => {
    try {
        const endpoint = `api/employee-master/get-userrights/${empCode}`
        const res = await apiCall({
            endpoint: endpoint,
            method: "GET"
        })
        return res;
    }
    catch (error) {
        throw error
    }
}

export const UpdateUserRights = async ({ payload }) => {

    const { empCode } = payload;
    try {
        const endpoint = `api/employee-master/update-userrights/${empCode}`
        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "PUT"
        })
        return res;
    }
    catch (error) {
        throw error;
    }
}

export const ImportEmployeeExcel = async ({ payload }) => {

    try {
        const endpoint = `api/employee-master/import-employees`
        const res = await apiCall({
            endpoint: endpoint,
            payload: payload,
            method: "POST"
        })
        return res
    }
    catch (error) {
        throw error;
    }
}

export const GetExcelFile = async ({ payload }) => {
    try {
        const endpoint = 'api/reports/employee-master-report'
        const res = await apiCall({
            endpoint: endpoint,
            method: "POST",
            payload: payload
        })
        return res;
    } catch (error) {
        throw error;
    }
}